import { DatePipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatFormField, MatHint, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { Package } from '../package'

@Component({
  selector: 'app-package-storage-location',
  template: `
    <div class="flex layout-col">
      <div class="layout-col">
        <h4 class="text-title-medium">
          {{ 'shopfloor.storage.currentLocation' | translate }}
        </h4>
        <div class="layout-row place-start-start gap-sm">
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>{{ 'shopfloor.storage.targetLocation' | translate }}</mat-label>
            <input
              matInput
              name="storageTarget"
              readonly
              placeholder="{{ 'shopfloor.storage.targetLocation' | translate }}"
              [(ngModel)]="pkg().storageTargetRoot"
            />
          </mat-form-field>
          <mat-form-field subscriptSizing="dynamic">
            <input
              matInput
              name="storagePath"
              readonly
              placeholder="-"
              [ngModel]="pkg().location?.storagePath"
            />
            <mat-hint>{{ pkg().location?.checkIn?.toString() | date: 'medium' }}</mat-hint>
            <mat-label>{{ 'shopfloor.storage.location' | translate }}</mat-label>
          </mat-form-field>
        </div>
      </div>
    </div>
  `,
  imports: [FormsModule, MatFormField, MatLabel, MatInput, MatHint, DatePipe, ElderTranslatePipe],
})
export class PackageStorageLocationComponent {
  pkg = input.required<Package>()
}
